import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'accounts-update-dialog',
  templateUrl: './accounts-update.component.html',
  styleUrls: ['./accounts-update.component.scss'],
})
export class AccountsUpdateComponent {
  constructor(public dialogRef: MatDialogRef<AccountsUpdateComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
